import { env } from '../../src/utils/env';

export const sharedApi = {
  // Share resources
  shareAccount: async (accountId: string, email: string): Promise<void> => {
    const response = await fetch(`${env.API_URL}/api/shared/accounts/${accountId}/share`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ 
        user_id: email,
        permissions: {
          view: true,
          transact: false
        }
      }),
    });

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.detail || 'Failed to share account');
    }
  },

  shareBudget: async (budgetId: string, email: string): Promise<void> => {
    const response = await fetch(`${env.API_URL}/api/shared/budgets/categories/${budgetId}/share`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ member_email: email }),
    });

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.detail || 'Failed to share budget');
    }
  },

  // Add permission checking methods
  checkPermission: async (type: 'account' | 'budget', resourceId: string, permission: string): Promise<boolean> => {
    const response = await fetch(
      `${env.API_URL}/api/shared/${type}s/${resourceId}/permissions/${permission}`,
      {
        credentials: 'include',
      }
    );

    if (!response.ok) {
      return false;
    }

    const data = await response.json();
    return data.has_permission;
  },
}; 